export default {
  isValid: (text: string) => {
    if (text === '') return true
    return /^\d+$/.test(text)
  },
}
